const l10n:FooterL10n =  {
  "linkList": {
    "companyLink": "Описание компании",
    "termsOfService": "Пользовательское соглашение",
    "privacyPolicy": "Политика конфиденциальности",
    "guaranteeOfRights": "Гарантия прав субъектов данных",
    "customerSupport": "Служба поддержки",
    "cookiePolicy": "Политика использования Cookies",
    "declarationOfSafety": "Декларация о безопасности",
    "youthProtectionPolicy": "Политика защиты несовершеннолетних",
    "communityPolicy": "Правила сообщества",
    "probability": "probability",
    "operationPolicy": "Политика пользования",
    "doNotSell": "Do Not Sell My Personal Information",
    "gameGrade": "게임이용등급",
    "communityPolicyView": "커뮤니티정책",
    "servicePolicy": "서비스정책",
    "termsOfUse": "Политика относительно участия",
    "operationPolicyNCJ": "운영방침",
    "reportRightsInfringement": "권리침해신고",
    "ncPrivacyCenter": "NC Privacy Center",
    "commercialTransactions": "특정상거래법에 의거한 표기",
    "settlementFund": "자금결제법에 따른 표시",
    "serviceTerm": "서비스 이용약관",
    "legalDocumentation": "Legal Documentation",
    "googleAPIDisclosure": "Google API Disclosure",
    "report": "신고하기",
    "serviceConsent": "Согласие на получение информации о сервисах NC",
    "careers": "Careers",
    "termsOfMobile": "모바일게임 약관"
  },
  "footerWords": {
    "gameRelatedLaw": "Дополнительные примечания в связи с законом о регулировании игр",
    "brandInformation": "Информация о названии компании",
    "copyright": "Авторское право",
    "channelingInfo": "NC Corporation является посредником в предоставлении игр с восможностью использования единого игрового ID в plaync, но не является заинтересованным лицом в осуществлении их продаж.<br>Все обязательства и ответственность, связанные с предоставлением данных игр, возлагается на официальных представителей по прадаже. За все проблемы, возникающие в данных играх, NC Corporation ответственности не несёт."
  },
  "infoCS": {
    "businessInformation": "Проверка данных предпринимателя",
    "infoAddress": "Название компании: NC Corporation. Исполнительные директора: Kim Taek-Jin, Park Byung-Moo. Номер удостоверения предпринимателя: 220-81-43000. <br>E-commerce Registration: 2026-Seongnam Bundang A-0316",
    "infoAddressNCV": "9 RAFFLES PLACE #26-01 REPUBLIC PLAZA SINGAPORE (048619)",
    "mobile": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020. Факс: +82-2-2186-3550",
    "pc": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020. Факс: +82-2-2186-3550",
    "ncfamilyzone": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020. Факс: +82-2-2186-3550",
    "other": "Адрес: 12, Daewangpangyo-ro 644beon-gil, Bundang-gu, Seongnam-si, Gyeonggi-do, Republic of Korea. Служба поддержки: +82-1600-0020. Факс: +82-2-2186-3550",
    "none": "",
    "infoEmail": "Электронная почта",
    "infoEmail-mobile": "MobileCS@ncsoft.com",
    "infoEmail-pc": "credit@ncsoft.com",
    "infoEmail-ncfamilyzone": "ncfamilyzone@ncsoft.com",
    "infoEmail-other": "credit@ncsoft.com/(игры для ПК)/MobileCS@ncsoft.com/(мобильные игры)",
    "infoEmail-none": ""
  },
  "infoJP": {
    "jpTitle": "Название",
    "jpGenre": "Жанр",
    "jpPrice": "Стоимость",
    "jpPriceValue": "Бесплатно (Поддерживаются покупки в приложении)",
    "jpOs": "Совместимая ОС",
    "jpPlatform": "Платформа",
    "jpDevelopedBy": "Отдел разработок/Отдел управления",
    "jpReleaseDay": "Дата выпуска",
    "jpReleaseDayValue_LW": "4 ноября 2021"
  },
  "country": {
    "KR": "Республика Корея",
    "TW": "Тайвань",
    "RU": "Россия",
    "MY": "Малайзия",
    "SA": "Саудовская Аравия",
    "SG": "Сингапур",
    "AE": "Арабские Эмираты",
    "ID": "Индонезия",
    "JP": "Япония",
    "QA": "Катар",
    "TH": "Таиланд",
    "PH": "Филиппины",
    "HK": "Гонконг",
    "UA": "Украина",
    "BY": "Белоруссия",
    "LT": "Литва",
    "PL": "Польша",
    "GR": "Греция",
    "IL": "Израиль",
    "KW": "Кувейт",
    "AT": "Австрия",
    "US": "США",
    "CA": "Канада",
    "DE": "Германия",
    "GB": "Великобритания",
    "FR": "Франция",
    "BR": "Бразилия",
    "IT": "Италия",
    "ES": "Испания",
    "CL": "Чили",
    "NO": "Норвегия",
    "SE": "Швеция",
    "IE": "Ирландия",
    "PT": "Португалия",
    "FI": "Финляндия",
    "DK": "Дания",
    "CH": "Швейцария",
    "AR": "Аргентина",
    "PE": "Перу",
    "MX": "Мексика",
    "KZ": "Казахстан",
    "UZ": "Узбекистан",
    "AZ": "Азербайджан",
    "GE": "Грузия",
    "MD": "Молдова",
    "AM": "Армения",
    "MO": "Макао",
    "IN": "Индия",
    "PK": "Пакистан",
    "NL": "Нидерланды",
    "RO": "Румыния",
    "AU": "Австралия",
    "TR": "Турция",
    "EC": "Эквадор",
    "CO": "Колумбия",
    "ZA": "Южная Африка",
    "EG": "Египет",
    "NC": "Global"
  }
};

export default l10n;
